<template>
  <div>
    <div class="pushtop" />
    <div class="feature_product_area petadd-wrapper">
      <div class="main_box">
        <EditPetListing />
      </div>
    </div>
  </div>
</template>

<script setup>
  import EditPetListing from '@/components/EditPetListing.vue';
</script>

<style scoped>
  @media (min-width: 992px) {
    .pushtop {
      min-height: 110px;
    }
  }
  @media (min-width: 1200px) {
    .pushtop {
      min-height: 175px;
    }
  }
</style>
